import * as React from "react";
import { DataGrid } from "@mui/x-data-grid";
import axios from "axios";
import DeleteIcon from "@mui/icons-material/Delete";
import image from "../logos/nodata.png";
import "./CommonDashboard.css";
import {useState } from "react";

import ConfirmationDialog from "./ConfirmationDialog";
import {
  makeStyles,
  createMuiTheme,
  ThemeProvider,
} from "@material-ui/core/styles";
import { Button} from "@mui/material";

import { useSelector, useDispatch } from "react-redux";


import { CssBaseline } from "@material-ui/core";
import Table from "@material-ui/core/Table";
import { setApikey } from "../redux/slices/apikeySlice";


const api= localStorage.getItem("api");
const theme = createMuiTheme({
  spacing: 2, 
  typography: {
    fontSize: 12, 
  },
});

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiDataGrid-row.Mui-selected": {
      backgroundColor: "#e0e0e0",
    },
    "& .MuiDataGrid-columnHeader": {
      backgroundColor: "#fafafa",
    },
    "& .MuiDataGrid-cell": {
      fontWeight: "normal",
      fontSize: "0.75rem",
      color: "rgba(0, 0, 0, 0.87)",
      letterSpacing: "0.01071em",
    },
    "& .MuiDataGrid-cell--textLeft": {
      textAlign: "left",
    },
    "& .MuiDataGrid-cell--textCenter": {
      textAlign: "center",
    },
    "& .MuiDataGrid-cell--textRight": {
      textAlign: "right",
    },
    "& .MuiDataGrid-columnsContainer": {
      backgroundColor: "#fafafa",
    },
    "& .MuiDataGrid-iconSeparator": {
      display: "none",
    },
  },
  table: {
    marginLeft: theme.spacing(1), 
    marginRight: theme.spacing(1), 
    width: `calc(100% - ${theme.spacing(3)}px)`,
    overFlow: "hidden", 
  },
}));

const ApikeyTable = () => {
  const [rows, setRows] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const headers = useSelector((state) => state.header);
  const classes = useStyles();
  const dispatch = useDispatch();
  const [showConfirmationDialog, setShowConfirmationDialog] = useState(false);
  const [deleteItemId, setDeleteItemId] = useState(null);
  const apikeydata = useSelector((state) => state.apikey);
   const columns = [
    { field: "name", headerName: "Name", flex:1 ,minWidth:200 },
    { field: "type", headerName: "Type", flex:1 ,minWidth:100  },
    {
      field: "key",
      headerName: "Key",
     minWidth:200 ,
      flex:3
    },
    {
      field: "delete",
      headerName: "Delete",
      flex:1,
      minWidth:120, 
      renderCell: (params) => (
        <Button
          variant="outlined"
          startIcon={<DeleteIcon />}
          color="error"
          onClick={() => handleDelete(params.row.id)}
          disabled={loading}
        >
          {loading ? "Deleting..." : "Delete"}
        </Button>
      ),
    },
  ];

  
  
  

  const handleDelete = (id) => {
    setDeleteItemId(id);
    setShowConfirmationDialog(true);
  };

  const handleConfirmDelete = () => {
    setShowConfirmationDialog(false);
    setLoading(true);

    axios
      .delete(api+`/apikeys?id=${deleteItemId}`, headers)
      .then(() => {
        setRows((prevRows) => {
          
          const updatedRows = prevRows?.filter((row) => row.id !== deleteItemId);
          dispatch(setApikey(updatedRows));
          return updatedRows;
        });
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleCancelDelete = () => {
    setShowConfirmationDialog(false);
  };




  React.useEffect(() => {
    if (apikeydata.apikey) setRows(apikeydata.apikey);
  }, [apikeydata.apikey]);

  return (
    <>
      {rows?.length > 0 ? (
        <CssBaseline>
          <ThemeProvider theme={theme}>
            <Table classes={classes.table}>
              <div className="emms-data-grid-container" style={{ padding: "2.5% 10%" }}>
                 <DataGrid
                  rows={rows}
                  columns={columns}
                  initialState={{
                    pagination: {
                      paginationModel: {
                        pageSize: 5,
                      },
                    },
                  }}
                  pageSizeOptions={[5]}
                  checkboxSelection
                  disableRowSelectionOnClick
                  sx={{ maxWidth: "100vw" }}
                />
              </div>
            </Table>
            {showConfirmationDialog && (
        <ConfirmationDialog
          open={showConfirmationDialog}
          onClose={handleCancelDelete}
          onConfirm={handleConfirmDelete}
        />
      )}
          </ThemeProvider>
        </CssBaseline>
      ) : (
        <div className="error-container">
          <div className="error">
            <img className="img1" src={image} alt="" />
          </div>
        </div>
      )}
    </>
  );
};

export default ApikeyTable;
